import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import CartButton from './CartButton';
import contactDealerLauncher from 'dibs-buyer-layout/exports/contactDealerLauncher';

function contactDealer(item, currency) {
    contactDealerLauncher({
        launchOrigin: 'contact link in favorites list',
        itemId: item.serviceId,
        sellerId: item.seller.serviceId,
        currency,
        modalType: 'REQUEST_PRICE',
    });
}

const CartRequestPriceButton = ({ item, currency }) => {
    return (
        <CartButton
            onClick={() => contactDealer(item, currency)}
            dataTn="item-actions-request-information"
        >
            <FormattedMessage
                id="CartRequestPriceButton.requestPrice"
                defaultMessage="Request Price"
            />
        </CartButton>
    );
};

CartRequestPriceButton.propTypes = {
    currency: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(CartRequestPriceButton, {
    item: graphql`
        fragment CartRequestPriceButton_item on Item {
            serviceId
            seller {
                serviceId
            }
        }
    `,
});
